import Unleash from '@js/plugins/unleash';

export default {
    computed: {
        hasVoidRuleEnabled() {
            return Unleash.hasFeature('void_rule_payment_wallet_card');
        },
        hasIsAllowPaymentReductionEnabled() {
            return Unleash.hasFeature('is_allow_payment_reduction');
        },
        hasIsShowPaymentInPosEnabled() {
            return Unleash.hasFeature('is_show_payment_in_pos');
        },
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/setting/settings-mixin.js